function previousElement(element: HTMLElement, selector?: string): HTMLElement | undefined {
    // Get the next sibling element
    let sibling = element.previousElementSibling as HTMLElement | undefined;

    // If there's no selector, return the first sibling
    if (selector == null) {
        return sibling;
    }

    /*
     * If the sibling matches our selector, use it
     * If not, jump to the next sibling and continue the loop
     */
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }

        sibling = sibling.previousElementSibling as HTMLElement | undefined;
    }

    //
    return sibling;
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        previousElement(selector?: string): HTMLElement | undefined;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.previousElement = function (selector?: string): HTMLElement | undefined {
    return previousElement(this, selector);
};

// ----------------------------------------------------------------------------

export default previousElement;
